import { useEffect, useMemo, useState } from 'react'
import { useQuery } from '@apollo/client/react'
import { GET_GIVEAWAY_SCHEDULE } from '@/services/Theatrical/queries'
import { resolveGiveawaySchedule } from '@/services/Theatrical/utils'
import { GetGiveawayScheduleQuery, GetGiveawayScheduleQueryVariables } from '@/types/codegen-federation'

export const useGiveawaySchedule = (theatricalSlug: string | undefined) => {
  const [isReady, setIsReady] = useState(false)

  const { data, refetch } = useQuery<GetGiveawayScheduleQuery, GetGiveawayScheduleQueryVariables>(
    GET_GIVEAWAY_SCHEDULE,
    {
      variables: { input: { projectSlug: theatricalSlug === 'rule-breakers-tech' ? 'rule-breakers' : theatricalSlug } },
    },
  )

  useEffect(() => {
    if (data) {
      setIsReady(true)
    }
  }, [data])

  return useMemo(() => {
    return {
      ...resolveGiveawaySchedule(data),
      isReady,
      refetch,
    }
  }, [data, isReady, refetch])
}
